module.exports = __webpack_public_path__ + "img/124.da6e86d4.jpg";